import type { BufferingMode } from '../enums';
import { FailedToLoadError } from '../errors';
import { BaseAsset } from './asset/BaseAsset';

/**
 */
export class BaseGroup extends BaseAsset {
    override _classType = 'BaseGroup';

    /**
     * @inheritDoc
     */
    override async _bufferAtTime(time: number, bufferingMode: BufferingMode) {
        await Promise.all(this._getBaseAssetsShallow().map(async(child) => {
            try {
                await child._bufferAtTime(time, bufferingMode);
            }
            catch (e: unknown) {
                // If an asset fails to load during buffering, we don't want to fail buffering overall
                // we'll let luminary do the best it can without this asset
                if (!(e instanceof FailedToLoadError)) {
                    throw e;
                }
            }
        }));
    }

    override _propagatePlay() {
        this._getBaseAssetsShallow().forEach(child => child._propagatePlay());
    }

    /**
     * @inheritDoc
     */
    override get canPlay() {
        return this._getBaseAssetsShallow().every(child => child.canPlay);
    }

    /**
     * @inheritDoc
     */
    override get isLoaded() {
        return this._getBaseAssetsShallow().every(child => child.isLoaded);
    }

    /**
     * @inheritDoc
     */
    override get isDoneTryingToLoad() {
        return this._getBaseAssetsShallow().every(child => child.isDoneTryingToLoad);
    }

    /**
     * @inheritDoc
     */
    override get shouldLoad() {
        return true;
    }

    /**
     * Forwards duration
     */
    get duration(): number {
        return this.container.duration;
    }

    /**
     * Forwards isPlaying from container
     */
    get isPlaying(): boolean {
        return this.container.isPlaying;
    }

    _getBaseAssetsShallow() {
        // We need to check for all base assets, not just "assets". For example,
        // The CaptionsManager is a BaseAsset with children but its not an "asset".
        return this._childAssets;
    }
}
